export const SIDEBAR_LOCALSTORAGE_KEY = 'pj:sidebarState';

export enum SIDEBAR_STATE {
  NONE = 'none',
  LISTS = 'lists',
  ALERTS = 'alerts',
  FILTER = 'filter',
  SETTINGS = 'settings',
  LOGIN = 'login',
}

export const DEFAULT_SIDEBAR_STATE = SIDEBAR_STATE.ALERTS;

export enum SORT_OPTIONS {
  USER_DEFINED = 'user_defined',
  ADDED = 'added',
  NAME = 'name',
  PRICE = 'price',
  PRICE_ASC = 'price:asc',
  PRICE_DESC = 'price:desc',
  CATEGORY = 'category',
  ACCESSED = 'accessed',
}

export const LIST_DELETE_TRANSITION_TIME = 500;

export const NO_MY_PRODUCTS_CREATED_ID = -1;
